import { HttpClient } from '../core/request'

// ------------------------------------
// Constants
// ------------------------------------
export const SET_CART_ITEMS_QTY = 'SET_CART_ITEMS_QTY'
export const SELECT_CHARITY = 'SELECT_CHARITY'

// ------------------------------------
// Actions
// ------------------------------------
export function setCartItemsQty (cartItemsQty) {
  return {
    type: SET_CART_ITEMS_QTY,
    payload: cartItemsQty
  }
}

export function updateCartItemsQty () {
  return (dispatch, getState) => {
    HttpClient(true).get('/cart').then(resp => {
      return dispatch({
        type: SET_CART_ITEMS_QTY,
        payload: resp.data.length
      })
    })
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SET_CART_ITEMS_QTY]: (state, action) => action.payload
}

// ------------------------------------
// Reducer
// ------------------------------------
export function cartItemsReducer (state = 0, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/cartItems.js